module.exports = __webpack_public_path__ + "img/winningRecord.1d7cf65f.png";